import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveRadialBar } from '@nivo/radial-bar';
import { GRAPH_STATUSES } from '../../../constants/constants';
import { CUSTOMER_ROLES } from '../../../constants/roles';
import Card from '../../Common/Card';
import { Menu } from 'primereact/menu';
import Modal61 from "../../Common/Modal/Modal61";
import Routes from '../../../constants/routes';
import './RadialBarGraph.scss';

const RadialBarGraph = ({ title, data, onClick, onHover, user, history, projectKey, projectId, onFilterByProject }) => {
    
    const colors = [
        GRAPH_STATUSES.NotApplicable.color, 
        GRAPH_STATUSES.Complete.color, 
        GRAPH_STATUSES.PastDue.color,
        GRAPH_STATUSES.InProgress.color,
        GRAPH_STATUSES.NotDue.color
    ]

    const ACTION_MENU_OPTIONS = {
        FilterOverview: 'filterOverview',
        PmDashboard: 'pmDashboard',
        AddLocation: 'addLocation'
    };

    let menuOptions = [
            { label: "Filter Overview by this project", value: ACTION_MENU_OPTIONS.FilterOverview, command: (e) => { menuOptionClick(e) } },
            { label: "Go to PM Dashboard", value: ACTION_MENU_OPTIONS.PmDashboard, command: (e) => { menuOptionClick(e) } },
            //{ label: "Add a location/team to project", value: ACTION_MENU_OPTIONS.AddLocation, command: (e) => { menuOptionClick(e) } }
        ];

    const isCustomerAdmin = () => {
        return [CUSTOMER_ROLES.Admin.name, CUSTOMER_ROLES.Moderator.name, CUSTOMER_ROLES.Owner.name].includes(user.customerRole);
    }

    let menuRef = useRef(null);
    let menuParentRef = useRef(null);
    let permissionsModal = React.useRef(null);

    const onActionsClick = (e) => {
        menuRef.current.toggle(e);
    }

    const menuOptionClick = async (e) => {
        switch (e.item.value) {
            case ACTION_MENU_OPTIONS.FilterOverview:
                onFilterByProject(projectId);
                break;
            case ACTION_MENU_OPTIONS.PmDashboard:
                if (!isCustomerAdmin())
                    permissionsModal.current.show();
                else
                    history.push(Routes.Admin + "/pm-dashboard/" + projectKey);
                break;
            case ACTION_MENU_OPTIONS.AddLocation:
                // TODO: do something when this is implemented
                break;
        }
    }

    const exitPermissionModal = () => {
        permissionsModal.current.hide();
    };

    return(
        <div className="radialbar-section">
            
            <Card>
                <div className="radialbar-content" style={{ height: '210px', width: '210px' }}>
                    <ResponsiveRadialBar
                        data={data}
                        colors={colors}
                        innerRadius={0.2}
                        padding={0.4}
                        cornerRadius={2}
                        margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                        enableTracks={true}
                        enableRadialGrid={false}
                        enableCircularGrid={false}
                        radialAxisStart={{ tickSize: 5, tickPadding: 5, tickRotation: 0 }}
                        circularAxisOuter={null}
                        animate={false}
                        onClick={onClick}
                        tooltip={onHover}
                    />
                    <div className='radialbar-title-container'>
                        <div className='radialbar-project-title'>{title}</div>
                        <div className='radialbar-menu' onClick={(e) => onActionsClick(e)} ref={menuParentRef}>
                            <Menu model={menuOptions} popup ref={el => menuRef.current = el} autoZIndex={false} baseZIndex={20001} appendTo={menuParentRef.current} className="quick-menu" />
                            <span className="fa-stack">
                                <i className="far fa-circle fa-stack-2x menu-icon-background"></i>
                                <i className="far fa-ellipsis fa-stack-1x menu-icon"></i>
                            </span>
                        </div>
                    </div>
                    
                </div>
            </Card>

            <Modal61 ref={permissionsModal}
                title="Insufficient Permissions"
                body={<span>This feature is restricted to administrators with <b>{user.currentSubscriptionName}</b>. Contact your administrator to have a project created or <a href="https://www.getpacer.com/contact" target="_blank" rel="noreferrer">reach out to Pacer</a> to get your own subscription to Pacer</span>}
                primaryButtonText="Ok"
                secondaryButtonText="Close"
                isCentered={true}
                onPrimaryClick={exitPermissionModal}
            />
        </div>
    )
}
RadialBarGraph.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    onHover: PropTypes.func,
    user: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    projectKey: PropTypes.string.isRequired,
    projectId: PropTypes.number.isRequired,
    onFilterByProject: PropTypes.func
}

export default RadialBarGraph;